(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elirian-reviews-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initList(wrap) {
    var grid = wrap.querySelector('.erh-grid');
    var cards = [].slice.call(grid.querySelectorAll('.erh-card'));
    var per = +wrap.closest('.erh').dataset.per || 6, shown = per;
    var fr = wrap.querySelector('[data-f=rating]'), fs = wrap.querySelector('[data-f=sort]');
    var count = wrap.querySelector('.erh-count'), none = wrap.querySelector('.erh-nomatch'), more = wrap.querySelector('.erh-more');
    var d = function (c, k) { return +c.dataset[k]; };
    var sorts = {
      newest: function (a, b) { return d(b, 'date') - d(a, 'date'); },
      high: function (a, b) { return d(b, 'rating') - d(a, 'rating') || d(b, 'date') - d(a, 'date'); },
      low: function (a, b) { return d(a, 'rating') - d(b, 'rating') || d(b, 'date') - d(a, 'date'); },
      votes: function (a, b) { return d(b, 'votes') - d(a, 'votes'); }
    };
    function render() {
      var list = cards.filter(function (c) { return fr.value === 'all' || c.dataset.rating === fr.value; }).sort(sorts[fs.value]);
      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c, i) { grid.appendChild(c); c.hidden = i >= shown; });
      count.textContent = list.length;
      none.hidden = list.length > 0;
      more.hidden = list.length <= shown;
    }
    function reset() { shown = per; render(); }
    fr.addEventListener('change', reset); fs.addEventListener('change', reset);
    more.addEventListener('click', function () { shown += per; render(); });
    wrap.querySelector('.erh-clear').addEventListener('click', function () { fr.value = 'all'; fs.value = 'newest'; reset(); });
    render();
  }

  function init(root) {
    if (root.dataset.erhInit) return;
    root.dataset.erhInit = '1';
    var tabs = [].slice.call(root.querySelectorAll('.erh__tab'));
    var panels = [].slice.call(root.querySelectorAll('.erh__panel'));
    function show(key, push) {
      tabs.forEach(function (t) { var on = t.dataset.tab === key; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p) { p.hidden = p.dataset.panel !== key; });
      if (push && history.replaceState) history.replaceState(null, '', '#' + key);
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t.dataset.tab, true); });
      t.addEventListener('keydown', function (e) {
        var step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        var next = tabs[(i + step + tabs.length) % tabs.length];
        next.focus(); show(next.dataset.tab, true);
      });
    });
    var h = location.hash.replace('#', '');
    show(tabs.some(function (t) { return t.dataset.tab === h; }) ? h : root.dataset.defaultTab, false);
    root.querySelectorAll('[data-list]').forEach(initList);
  }

  function boot() { document.querySelectorAll('.erh').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
